import { UserModel } from '@modules/auth/user-model';

const fields = new UserModel().fields();

export default [
  fields.email,
  fields.firstName,
  fields.lastName,
  fields.phoneNumber,
  fields.avatarsIam,
  fields.roles,
];
